import {VehicleRecommendationType} from '@dms/shared';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

interface VehicleIdentificationSubSectionProps {
  variant?: VehicleRecommendationType;
}

export function VehicleIdentificationSubSection({
  variant = 'sale',
}: VehicleIdentificationSubSectionProps) {
  return (
    <VFKit.SubSection data-testid="vehicle-identification">
      <VFKit.VinDecoderField variant={variant} shouldRecommendVehicles hideChooseButton />
      <VFKit.BodyTypeChips />
    </VFKit.SubSection>
  );
}
